import { createFileRoute } from "@tanstack/react-router";
import { HERNANDO_GALVALUME_STUDY as study } from "@/components/site/case-studies";
import { ProjectStudyPage, projectStudyHead } from "@/components/site/CaseStudy";

export const Route = createFileRoute("/projects/galvalume-metal-roof-hernando-fl")({
  head: () => projectStudyHead(study),
  component: Page,
});

function Page() {
  return <ProjectStudyPage study={study} />;
}
